import { render, staticRenderFns } from "./EditInventoryCache.vue?vue&type=template&id=b54bcc22&scoped=true"
import script from "./EditInventoryCache.vue?vue&type=script&lang=js"
export * from "./EditInventoryCache.vue?vue&type=script&lang=js"
import style0 from "./EditInventoryCache.vue?vue&type=style&index=0&id=b54bcc22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54bcc22",
  null
  
)

export default component.exports